import React from "react";
import ContactFirstLoad from "./functions/Contact.FirstLoad";
import ContactBanner from "./render/Contact.Banner";
import ContactList from "./render/Contact.List";
import MetaTags from "../../utils/useMetaTags";
import { ContextLanguage } from "../../context/Context.Language";

const ContactMain = () => {
  const { language } = React.useContext(ContextLanguage);

  React.useEffect(() => {
    ContactFirstLoad();
  }, []);

  return (
    <div id="scroll_contact" className="min-h-screen">
      {language === "TH" ? (
        <MetaTags
          title="ติดต่อเรา - กรุงเทพ | My Laundry"
          description="สั่งออเดอร์ผ่านเว็บไซด์ของเราตลอด 24 ชม. หรือผ่านแอปเแชทโดยตรง เลือกช่องทางที่เหมาะกับคุณที่สุด เพื่อใช้บริการซักรีดและซักรองเท้าตอนนี้เลย!"
        />
      ) : (
        <MetaTags
          title="Contact Us - Bangkok | My Laundry"
          description="Order through our website 24/7 or contact us personally. Choose the channel that suits you best & place your laundry or shoe cleaning service order NOW!"
        />
      )}

      <ContactBanner />
      <ContactList />
    </div>
  );
};
export default ContactMain;
